import {
  Box,
  Button,
  Dialog,
  DialogProps,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  OutlinedInput,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Stack,
  Theme,
  useTheme,
} from "@mui/material";
import React, { useCallback } from "react";
import Radio from "@mui/material/Radio";
// import styles from "@/styles/components/filterModal.module.scss";
// import Image from "next/image";
// import assest from "@/json/assest";
import assest from "../../json/assest";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      "& .MuiList-root": {
        "& .MuiMenuItem-root": {
          fontWeight: "500",
          fontSize: "11px",
          color: "#525050",
        },
      },
    },
  },
};

const names = [
  "Lorem Ipsum",
  "Lorem Ipsum1",
  "Lorem Ipsum2",
  "Lorem Ipsum3",
  "Lorem Ipsum4",
  "Lorem Ipsum5",
  "Lorem Ipsum6",
  "Lorem Ipsum7",
  "Lorem Ipsum8",
  "Lorem Ipsum9",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
// export type FilterModalProps = DialogProps & {
//   hideBottom?: boolean;
//   confirmedByColName?: string;
//   hideApprovedByCol?: string;
//   approvedByColName?: string;
//   hideConfirmedByCol?: boolean;
//   type?: 'filter_QC' | 'home_filter'
// };

const FilterModal = (props) => {
  const {
    hideBottom,
    onClose,
    confirmedByColName,
    approvedByColName,
    hideApprovedByCol,
    hideConfirmedByCol,
    ...rest
  } = props;

  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const [filmedInMonth, setfilmedInMonth] = React.useState([]);
  const [filmedInYear, setfilmedInYear] = React.useState([]);
  const [filmingLocation, setfilmingLocation] = React.useState([]);
  // const [getAcquisitor, setUserId] = React.useState([]);
  const [markedBy, setMarkedBy] = React.useState([]);
  const [rejectedBy, setRejectedBy] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const handleChangeFilmedInmonth = (
    event
  ) => {
    const {
      target: { value },
    } = event;
    setfilmedInMonth(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const handleChangeFilmedInYear = (
    event
  ) => {
    const {
      target: { value },
    } = event;
    setfilmedInYear(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleChangeFilmingLocation = (
    event
  ) => {
    const {
      target: { value },
    } = event;
    setfilmingLocation(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  // const handleChangeAcquisitor = (
  //   event
  // ) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setUserId(
  //     // On autofill we get a stringified value.
  //     typeof value === "string" ? value.split(",") : value
  //   );
  // };

  const handleMarkedby = (event) => {
    const {
      target: { value },
    } = event;
    setMarkedBy(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleRejectedby = (event) => {
    const {
      target: { value },
    } = event;
    setRejectedBy(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
    },
    [onClose]
  );

  return (
    <Dialog
      className="filterModal forFilter partnerFilter"
      {...rest}
      onClose={handleClose}
    >
      <Box className="filterModalWrapper">
        <Box className="filterModalHeader">
          <h4>Filter</h4>
          <Button>
            <img src={assest.resetIcon} width={9} height={9} alt="" />
            <p>Clear</p>
          </Button>
        </Box>

        <Box className="filterModalBody">
          <Box className="filterBodyBox">
            <Stack
              direction={"row"}
              alignItems={"center"}
              flexWrap={"wrap"}
              className="chooseFilterRow"
            >
              <Box className="filterBoxItem hasNote">
                <Box className="groupBottm">
                  <label>
                    Has Notes?{" "}
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>
                  {/* <Box className="filterRadio">
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </Box> */}
                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        name="radio-buttons-group"
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="No"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
                <Box className="groupBottm">
                  <label>
                    Filmed in{" "}
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>
                  <Box className="filterSelect filterSelectSmall">
                    <Select
                      // multiple
                      displayEmpty
                      value={filmedInMonth}
                      onChange={handleChangeFilmedInmonth}
                      input={<OutlinedInput />}
                      renderValue={(selected) => {
                        if (selected.length === 0) {
                          return <span>Month</span>;
                        }

                        return selected.join(", ");
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ "aria-label": "Without label" }}
                      className="selectInput selectMonth"
                    >
                      {/* <MenuItem disabled value="">
                    <span>Month</span>
                  </MenuItem> */}
                      {names.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          style={getStyles(name, personName, theme)}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>

                    <Select
                      // multiple
                      displayEmpty
                      value={filmedInYear}
                      onChange={handleChangeFilmedInYear}
                      input={<OutlinedInput />}
                      renderValue={(selected) => {
                        if (selected.length === 0) {
                          return <span>Year</span>;
                        }

                        return selected.join(", ");
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ "aria-label": "Without label" }}
                      className="selectInput selectYear"
                    >
                      {/* <MenuItem disabled value="">
                    <span>Year</span>
                  </MenuItem> */}
                      {names.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          style={getStyles(name, personName, theme)}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>
              </Box>
              <Box className="filterBoxItem unreachableSubmitter">
                <Box className="groupBottm">
                  <label>
                    Unreachable Submitter?{" "}
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>
                  {/* <Box className="filterRadio">
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </Box> */}
                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        name="radio-buttons-group"
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="No"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
                <Box className="groupBottm">
                  <label>
                    Filming Location{" "}
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>
                  <Box className="filterSelect">
                    <Select
                      // multiple
                      displayEmpty
                      value={filmingLocation}
                      onChange={handleChangeFilmingLocation}
                      input={<OutlinedInput />}
                      renderValue={(selected) => {
                        if (selected.length === 0) {
                          return <span></span>;
                        }

                        return selected.join(", ");
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {/* <MenuItem disabled value="">
                    <span>Placeholder</span>
                  </MenuItem> */}
                      {names.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          style={getStyles(name, personName, theme)}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>
              </Box>
              <Box className="filterBoxItem hasPending">
                <Box className="groupBottm">
                  <label>
                    Has Pending Message{" "}
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>
                  {/* <Box className="filterRadio">
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </Box> */}
                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        name="radio-buttons-group"
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="No"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
                <Box className="groupBottm">
                  <label>
                    Acquisitor{" "}
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>
                  <Box className="filterSelect">
                    <Select
                      // multiple
                      displayEmpty
                      // value={getAcquisitor}
                      // onChange={handleChangeAcquisitor}
                      // input={<OutlinedInput />}
                      renderValue={(selected) => {
                        if (selected?.length === 0) {
                          return <span></span>;
                        }

                        return selected?.join(", ");
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {/* <MenuItem disabled value="">
                    <span>Placeholder</span>
                  </MenuItem> */}
                      {names.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          style={getStyles(name, personName, theme)}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>
              </Box>
              <Box className="filterMarkConfirm decisionBy">
                {props?.type !== "filter_QC" ? (
                  <>
                    <Box className="filterBoxItem">
                      {/* <label>
    Marked by{" "}
    <img
      src={assest.resetIconBlue}
      width={9}
      height={9}
      alt=""
    />
  </label> */}
                      {!hideApprovedByCol ? (
                        <label>
                          {approvedByColName || "Marked by"}{" "}
                          <img
                            src={assest.resetIconBlue}
                            width={9}
                            height={9}
                            alt=""
                          />
                        </label>
                      ) : null}
                      <Box className="filterSelect">
                        <Select
                          // multiple
                          displayEmpty
                          value={markedBy}
                          onChange={handleMarkedby}
                          input={<OutlinedInput />}
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return <span></span>;
                            }

                            return selected.join(", ");
                          }}
                          MenuProps={MenuProps}
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          {/* <MenuItem disabled value="">
    <span>Placeholder</span>
  </MenuItem> */}
                          {names.map((name) => (
                            <MenuItem
                              key={name}
                              value={name}
                              style={getStyles(name, personName, theme)}
                            >
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>
                    </Box>
                    <img
                      src={assest.purpleArrowIcon}
                      width={53}
                      height={2}
                      alt=""
                      className="purpleArrowIcon"
                    />
                    <Box className="filterBoxItem">
                      {/* <label>
    Confirmed by{" "}
    <img
      src={assest.resetIconBlue}
      width={9}
      height={9}
      alt=""
    />
  </label> */}

                      {!hideConfirmedByCol ? (
                        <label>
                          {confirmedByColName || "Rejected by"}{" "}
                          <img
                            src={assest.resetIconBlue}
                            width={9}
                            height={9}
                            alt=""
                          />
                        </label>
                      ) : null}
                      <Box className="filterSelect">
                        <Select
                          // multiple
                          displayEmpty
                          value={rejectedBy}
                          onChange={handleRejectedby}
                          input={<OutlinedInput />}
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return <span></span>;
                            }

                            return selected.join(", ");
                          }}
                          MenuProps={MenuProps}
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          {/* <MenuItem disabled value="">
    <span>Placeholder</span>
  </MenuItem> */}
                          {names.map((name) => (
                            <MenuItem
                              key={name}
                              value={name}
                              style={getStyles(name, personName, theme)}
                            >
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>
                    </Box>
                  </>
                ) : (
                  <Box className="filterBoxItem">
                    {/* <label>
    Confirmed by{" "}
    <img
      src={assest.resetIconBlue}
      width={9}
      height={9}
      alt=""
    />
  </label> */}

                    {!hideConfirmedByCol ? (
                      <label>
                        {confirmedByColName || "Approved by"}{" "}
                        <img
                          src={assest.resetIconBlue}
                          width={9}
                          height={9}
                          alt=""
                        />
                      </label>
                    ) : null}
                    <Box className="filterSelect">
                      <Select
                        // multiple
                        displayEmpty
                        value={rejectedBy}
                        onChange={handleRejectedby}
                        input={<OutlinedInput />}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return <span></span>;
                          }

                          return selected.join(", ");
                        }}
                        MenuProps={MenuProps}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        {/* <MenuItem disabled value="">
    <span>Placeholder</span>
  </MenuItem> */}
                        {names.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                            style={getStyles(name, personName, theme)}
                          >
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  </Box>
                )}
              </Box>
            </Stack>
          </Box>

          {!hideBottom ? (
            <Box className="filterBodyBox filterBodyBox2">
              <Box className="filterBoxItem">
                <label>
                  Are There People Appearing In The Video?{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                {/* <Box className="filterRadio">
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </Box> */}

                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      name="radio-buttons-group"
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className="filterBoxItem">
                <label>
                  The Person Who Filmed This Video Is:{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                {/* <Box className="filterRadio">
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Me"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="A Family Member"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="A Friend"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Someone I Know"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="A Dashcam"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="A Security Camera"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Other: the kid of my friend"
                  />
                </Box> */}

                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      name="radio-buttons-group"
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="Me"
                          control={<Radio />}
                          label="Me"
                        />
                        <FormControlLabel
                          value="Member"
                          control={<Radio />}
                          label="A Family Member"
                        />
                        <FormControlLabel
                          value="Friend"
                          control={<Radio />}
                          label="A Friend"
                        />
                        <FormControlLabel
                          value="Know"
                          control={<Radio />}
                          label="Someone I Know"
                        />
                        <FormControlLabel
                          value="Dashcam"
                          control={<Radio />}
                          label="A Dashcam"
                        />
                        <FormControlLabel
                          value="Camera"
                          control={<Radio />}
                          label="A Security Camera"
                        />
                        <FormControlLabel
                          value="friend"
                          control={<Radio />}
                          label="Other: the kid of my friend"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className="filterBoxItem">
                <label>
                  Did You Send/Submit/Upload This Video To A Website And/Or
                  Social Media Account?{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                {/* <Box className="filterRadio">
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="No, I Did Not"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Yes, Another Company's Website"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Yes, A Facebook Page"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Yes, A Twitter Account"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Yes, An Instagram Account"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Yes, A YouTube Channel"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Yes, A Snaphat Account"
                  />
                </Box> */}
                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      name="radio-buttons-group"
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="Not"
                          control={<Radio />}
                          label="No, I Did Not"
                        />
                        <FormControlLabel
                          value="Website"
                          control={<Radio />}
                          label="Yes, Another Company's Website"
                        />
                        <FormControlLabel
                          value="Page"
                          control={<Radio />}
                          label="Yes, A Facebook Page"
                        />
                        <FormControlLabel
                          value="Twitter"
                          control={<Radio />}
                          label="Yes, A Twitter Account"
                        />
                        <FormControlLabel
                          value="Instagram"
                          control={<Radio />}
                          label="Yes, An Instagram Account"
                        />
                        <FormControlLabel
                          value="Channel"
                          control={<Radio />}
                          label="Yes, A YouTube Channel"
                        />
                        <FormControlLabel
                          value="Snaphat"
                          control={<Radio />}
                          label="Yes, A Snaphat Account"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className="filterBoxItem">
                <label>
                  Did You Sign A Licensing Agreement For This Video With Another
                  Company/Page?{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                {/* <Box className="filterRadio">
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="No, I Did Not"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Yes, I Have Filled An Online Form"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Yes, I Have Signed An Exclusive Agreement"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Yes, I Have Signed A Non-Exclusive Agreement"
                  />
                </Box> */}
                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      name="radio-buttons-group"
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="Not"
                          control={<Radio />}
                          label="No, I Did Not"
                        />
                        <FormControlLabel
                          value="Online"
                          control={<Radio />}
                          label="Yes, I Have Filled An Online Not"
                        />
                        <FormControlLabel
                          value="Exclusive"
                          control={<Radio />}
                          label="Yes, I Have Signed An Exclusive Agreement"
                        />
                        <FormControlLabel
                          value="NonExclusive"
                          control={<Radio />}
                          label="Yes, I Have Signed A Non-Exclusive Agreement"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            </Box>
          ) : null}
        </Box>

        <Box className="filterModalFooter">
          <Box className="buttonGroup">
            <Button onClick={handleClose}>Cancel</Button>
            <Button className="activeButton" onClick={handleClose}>
              Filter now
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default FilterModal;
